function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import animations from '../../styles/animations';
import { curves } from '../../styles/theme';
export function animated(ComposedComponent, defaults) {
  const componentName = ComposedComponent.displayName || ComposedComponent.name || 'Component';
  const AnimatedComponent = styled(ComposedComponent).withConfig({
    displayName: "withAnimation__AnimatedComponent",
    componentId: "wuzb9v-0"
  })(["", ";", ";animation:", ";animation-delay:", "ms;animation-direction:", ";animation-duration:", "ms;animation-fill-mode:", ";animation-iteration-count:", ";animation-timing-function:", ";"], css(["", ";"], x => x.enterStyles), x => x.animation.indexOf('In') > -1 && css(["opacity:0;"]), x => x.animation !== 'none' ? animations[x.animation] : '', x => x.animationDelay, x => x.animationDirection, x => x.animationDuration, x => x.animationFillMode, x => x.animationIterations, x => curves[x.animationEasing]).withComponent((_ref) => {
    let {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      animation,
      animationDelay,
      animationDirection,
      animationDuration,
      animationFillMode,
      animationEasing,
      animationIterations,
      enterStyles
    } = _ref,
        rest = _objectWithoutProperties(_ref, ["animation", "animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationEasing", "animationIterations", "enterStyles"]);

    return /*#__PURE__*/React.createElement(ComposedComponent, rest);
  });
  AnimatedComponent.displayName = componentName;
  AnimatedComponent.defaultProps = _objectSpread({
    animation: 'none',
    animationDelay: 0,
    animationDirection: 'normal',
    animationDuration: 500,
    animationFillMode: 'forwards',
    animationEasing: 'standard',
    animationIterations: 1
  }, defaults);

  const ComponentWithAnimation = props => {
    return props.animation === 'none' ? /*#__PURE__*/React.createElement(ComposedComponent, props) : /*#__PURE__*/React.createElement(AnimatedComponent, props);
  };

  ComponentWithAnimation.displayName = `${componentName}_withAnimation`;
  return ComponentWithAnimation;
}
export default animated;